module.exports = __webpack_public_path__ + "static/ss1-6b4af29c3e7d5adef01616aaf45a3acb.png";